// src/utils/HrvUtil.ts

import { mathUtil } from "./MathUtil"

class HrvUtil {

    /** 格式化 RR 数据
     * @param rate 采样率(每秒的采样个数)
     * @param peekIndexList 波峰出现在采样点的索引数组
     */
    formatPeek(rate: number, peekIndexList: number[]) {
        let peekList = []
        for (let i = 0; i < peekIndexList.length; i++) {
            const peek = peekIndexList[i]
            peekList.push([i, Math.floor(peek / rate), peek])
        }
        return peekList
    }

    /** 求 RR.
     * @param rate 采样率(每秒的采样个数)
     * @param peekList 波峰出现的采样计数
     * @returns 
     */
    calcRr(rate: number, peekList: number[][]) {
        // const rate = 512
        let rrList = [[0, 0, 0]]
        for (let i = 0; i < peekList.length - 1; i++) {
            let rr = Math.floor((peekList[i + 1][2] - peekList[i][2]) / rate * 1000)
            rrList.push([i + 1, peekList[i + 1][1], rr])
        }
        return rrList
    }

    /** 求SDNN.
     * @param lastTime 样本取样时长(单位: 秒)
     * @param rrList RR数组(间隔时长的单位是毫秒)
     * @returns 
     */
    calcSdnn(lastTime: number, rrList: number[][]) {
        let sdnn = [[0, 0, 0]]
        let tempRrList = []
        for (let i = 1; i < rrList.length; i++) {
            const rr = rrList[i]
            const time = rrList[i][1]
            tempRrList.push(rr)
            if (time <= lastTime) {
                sdnn.push([rrList[i][0], time, 0])
            }
            else {
                // 求前30s的方差
                let valList = []
                for (let j = 0; j < tempRrList.length; j++) {
                    valList.push(tempRrList[j][2])
                }
                let v = mathUtil.variance(valList)
                sdnn.push([rrList[i][0], time, v])
                // 从 tempRrList 中移除30秒以前的数据
                for (let j = tempRrList.length - 1; j > 0; j--) {
                    if (tempRrList[j][1] <= time - lastTime) {
                        // if (i < 100) console.log(`移除个数:`, j)
                        for (let k = 0; k < j; k++) {
                            tempRrList.shift()
                        }
                        break
                    }
                }
            }
        }
        return sdnn
    }

    /** 计算 NN50 数据(相邻两个RR间隔差是否超过了50ms)
     * @param rrList 
     * @returns 
     */
    calcNn50(rrList: number[][]) {
        let nn50 = [[0, 0, 0], [1, 0, 0]]
        for (let i = 2; i < rrList.length; i++) {
            const rrLast = rrList[i - 1]
            const rrThis = rrList[i]
            let val = Math.abs(rrThis[2] - rrLast[2]) > 50 ? 1 : 0
            nn50.push([i, rrThis[1], val, rrThis[2] - rrLast[2]])
        }
        // for (let i = 0; i < nn50.length; i++) {
        //     const nn = nn50[i]
        //     if (i < 50) console.log(`[${i}] nn:`, nn)
        // }
        return nn50
    }

    /** 计算 pNN50_x(x为计算的时间范围，单位是秒)
     * @param lastTime 样本取样时长(单位: 秒)
     * @param rrList RR数组(间隔时长的单位是毫秒)
     * @param nn50List 相邻两个RR间隔差是否超过了50ms
     * @returns 
     */
    calcPnn50(lastTime: number, rrList: number[][], nn50List: number[][]) {
        let pnn50 = [[0, 0, 0]]
        let tempNn50List = []
        for (let i = 1; i < nn50List.length; i++) {
            const rr = nn50List[i]
            const time = nn50List[i][1]
            tempNn50List.push(rr)
            if (time <= lastTime) {
                pnn50.push([nn50List[i][0], time, 0])
            }
            else {
                // 求前30s NN > 50ms 的个数
                let count = 0
                for (let j = 0; j < tempNn50List.length; j++) {
                    if (tempNn50List[j][2] > 0) {
                        count++
                    }
                }
                // if (i > nn50List.length - 100) console.log(`[${i}] count:【${count}】, tempNn50List.length:`, tempNn50List.length)
                // pnn50.push([rrList[i][0], time, Math.round(count * 100 / tempNn50List.length)])
                pnn50.push([rrList[i][0], time, Math.round(count * 100 / tempNn50List.length), count, tempNn50List.length])
                // 从 tempRrList 中移除 lastTime 秒以前的数据
                for (let j = tempNn50List.length - 1; j > 0; j--) {
                    if (tempNn50List[j][1] <= time - lastTime) {
                        for (let k = 0; k < j; k++) {
                            tempNn50List.shift()
                        }
                        break
                    }
                }
            }
        }
        return pnn50
    }
}

export let hrvUtil = new HrvUtil()